import React, { useEffect, useRef, useState } from "react";
import FlightSearch from "../components/componentsForHome/FlightSearch";
import FlightFilter from "../components/componentsForHome/FlightFilter";
import FlightResult from "../components/componentsForHome/FlightResult";
import LoadingPage from "../components/LoadingPage";
import socketIOClient from "socket.io-client";
import { decodeData, formatDate } from "../helpers/function_helper";
import { timChuyen } from "../services/flightService";
import SweetAlert from "react-bootstrap-sweetalert";
import { useNavigate } from "react-router-dom";
import "./Home.css";

export default function Home() {
  const socketRef = useRef();
  const timeoutRef = useRef(null); // Thêm ref cho timeout

  // Xóa localStorage khi vào trang Home
  useEffect(() => {
    localStorage.removeItem('isOnResponsePage');
  }, []);

  const [dataChuyenBay, setDataChuyenBay] = useState({
    chieu_di: [],
    chieu_ve: [],
  });
  const [displayedFlights, setDisplayedFlights] = useState({
    chieu_di: [],
    chieu_ve: [],
  });
  const [flightWaySelected, setFlightWaySelected] = useState({});
  const [flightToSelected, setFlightToSelected] = useState({});
  const [apiResponeSocket, setApiResponeSocket] = useState({});
  const [sweetAlert, setSweetAlert] = useState({
    isShow: false,
    baseProps: {},
  });
  const [loading, setLoading] = useState(false);
  const [pageTransitionLoading, setPageTransitionLoading] = useState(false); // Loading khi chuyển page
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [passengerCounts, setPassengerCounts] = useState({
    adults: 1,
    children: 0,
    infants: 0,
  });
  const [searchInfo, setSearchInfo] = useState(null); // Lưu thông tin form search
  const flightToSectionRef = useRef(); // Thêm ref cho FlightResult
  const navigate = useNavigate();
  
  const [showReturnFlights, setShowReturnFlights] = useState(false);
  const [showDepartureFlights, setShowDepartureFlights] = useState(true);

  const [socketDisconnected, setSocketDisconnected] = useState(false);
  const [checkedStop, setCheckedStop] = useState([]);
  const [checkedAirline, setCheckedAirline] = useState([]);

  // Logic hiển thị chuyến bay mới: Tự động mở rộng khi có đủ dữ liệu
  useEffect(() => {
    const currentDepartureDisplayed = displayedFlights.chieu_di.length;
    const totalDeparture = dataChuyenBay.chieu_di.length;
    
    // Khởi tạo displayedFlights khi chuyển về showDepartureFlights
    if (showDepartureFlights && currentDepartureDisplayed === 0 && totalDeparture > 0) {
      let initialDisplayed;
      if (socketDisconnected) {
        // Socket đã ngắt - hiển thị toàn bộ chuyến bay
        initialDisplayed = dataChuyenBay.chieu_di;
      } else {
        // Socket còn hoạt động - hiển thị 5 chuyến đầu tiên
        initialDisplayed = dataChuyenBay.chieu_di.slice(0, 5);
      }
      
      setDisplayedFlights(prev => ({
        ...prev,
        chieu_di: initialDisplayed,
      }));
      return; // Thoát sớm để tránh xử lý logic khác
    }
    
    // Tự động hiển thị thêm chuyến bay chiều đi khi:
    // 1. Có dữ liệu mới và chưa hiển thị hết
    // 2. Đang hiển thị danh sách chiều đi
    if (showDepartureFlights && totalDeparture > currentDepartureDisplayed) {
      let newDisplayed;
      if (socketDisconnected && totalDeparture > 0) {
        // Socket đã ngắt - hiển thị toàn bộ chuyến bay
        newDisplayed = dataChuyenBay.chieu_di;
      } else {
        // Socket còn hoạt động - hiển thị từng batch 5 chuyến
        const nextBatch = Math.min(currentDepartureDisplayed + 5, totalDeparture);
        newDisplayed = dataChuyenBay.chieu_di.slice(0, nextBatch);
      }
      
      setDisplayedFlights(prev => ({
        ...prev,
        chieu_di: newDisplayed,
      }));
    }

    // Tắt loading khi có ít nhất 5 chuyến chiều đi hoặc socket đã ngắt
    if ((dataChuyenBay.chieu_di.length >= 5 || socketDisconnected) && loading) {
      setLoading(false);
    }
  }, [dataChuyenBay.chieu_di, showDepartureFlights, loading, socketDisconnected, displayedFlights.chieu_di.length]);

  // Logic hiển thị chuyến bay chiều về: Tự động mở rộng khi có đủ dữ liệu
  useEffect(() => {
    if (showReturnFlights && flightWaySelected && Object.keys(flightWaySelected).length > 0) {
      let allReturnFlights = []; 
      if (flightWaySelected.hang_bay.api !== "uAPI") {
        // Hãng bay thường (không phải uAPI): hiển thị tất cả chuyến về KHÔNG phải uAPI
        allReturnFlights = dataChuyenBay.chieu_ve.filter(f => f.hang_bay.api !== "uAPI");
      } else {
        // uAPI: chỉ hiển thị chuyến về có cùng index và là uAPI
        allReturnFlights = dataChuyenBay.chieu_ve.filter(
          flight => flight.index === flightWaySelected.index && flight.hang_bay.api === "uAPI"
        );
      }
      
      const currentDisplayed = displayedFlights.chieu_ve.length;
      const totalAvailable = allReturnFlights.length;
      
      // Tự động hiển thị thêm khi có dữ liệu mới
      if (totalAvailable > currentDisplayed) {
        const nextBatch = Math.min(currentDisplayed + 5, totalAvailable);
        const newDisplayed = allReturnFlights.slice(0, nextBatch);
        setDisplayedFlights(prev => ({
          ...prev,
          chieu_ve: newDisplayed,
        }));
      }
      
      // Nếu chưa có dữ liệu nào, hiển thị ban đầu
      if (currentDisplayed === 0 && totalAvailable > 0) {
        let initialReturnFlights;
        if (socketDisconnected) {
          // Socket đã ngắt - hiển thị toàn bộ chuyến bay về
          initialReturnFlights = allReturnFlights;
        } else {
          // Socket còn hoạt động - hiển thị 5 chuyến đầu tiên
          initialReturnFlights = allReturnFlights.slice(0, 5);
        }
        setDisplayedFlights(prev => ({
          ...prev,
          chieu_ve: initialReturnFlights,
        }));
      }
    } else {
      setDisplayedFlights(prev => ({
        ...prev,
        chieu_ve: [],
      }));
    }
  }, [showReturnFlights, flightWaySelected, dataChuyenBay.chieu_ve, socketDisconnected]);

  // Xử lý khi chọn chuyến chiều đi
  const handleFlightWaySelected = (flight) => {
    setFlightWaySelected(flight);
    
    // Logic hiển thị chiều về dựa trên hãng bay
    if (searchInfo?.type === "roundtrip") {
      // Bắt đầu loading transition
      setPageTransitionLoading(true);
      
      setTimeout(() => {
        setShowDepartureFlights(false); // Ẩn danh sách chiều đi
        setShowReturnFlights(true); // Luôn hiển thị màn hình chọn chuyến về
        
        // Scroll lên card thông tin chiều về sau khi hiển thị
        setTimeout(() => {
          const returnInfoCard = document.querySelector('[data-return-info-card]');
          if (returnInfoCard) {
            returnInfoCard.scrollIntoView({
              behavior: "smooth",
              block: "start",
              inline: "nearest"
            });
          }
        }, 100); // Delay nhỏ để đảm bảo DOM đã render
        
        // Tắt loading transition sau 0.3s
        setPageTransitionLoading(false);
      }, 500); // Loading 0.3s
    }
  };

  // Xử lý khi chọn chuyến chiều về
  const handleFlightToSelected = (flight) => {
    setFlightToSelected(flight);
  };

  // Tự động load more khi có dữ liệu mới đến - KHÔNG CẦN SCROLL
  useEffect(() => {
    // Auto load more cho chiều đi khi có dữ liệu mới
    if (showDepartureFlights && !loading) {
      const currentDisplayed = displayedFlights.chieu_di.length;
      const totalAvailable = dataChuyenBay.chieu_di.length;
      
      // Logic khác biệt dựa trên trạng thái socket
      if (socketDisconnected && totalAvailable > currentDisplayed) {
        // Socket đã ngắt - hiển thị toàn bộ chuyến bay còn lại
        const newDisplayed = dataChuyenBay.chieu_di;
        setDisplayedFlights(prev => ({
          ...prev,
          chieu_di: newDisplayed,
        }));
      } else if (!socketDisconnected && totalAvailable >= currentDisplayed + 5) {
        // Socket còn hoạt động - hiển thị từng batch 5 chuyến
        const nextBatch = currentDisplayed + 5;
        const newDisplayed = dataChuyenBay.chieu_di.slice(0, nextBatch);
        
        setDisplayedFlights(prev => ({
          ...prev,
          chieu_di: newDisplayed,
        }));
      }
    }
  }, [dataChuyenBay.chieu_di.length, showDepartureFlights, loading, socketDisconnected]);

  // Tự động load more cho chiều về khi có dữ liệu mới
  useEffect(() => {
    if (showReturnFlights && flightWaySelected && Object.keys(flightWaySelected).length > 0) {
      const allReturnFlights = getReturnFlights();
      const currentDisplayed = displayedFlights.chieu_ve.length;
      const totalAvailable = allReturnFlights.length;
      
      // Logic khác biệt dựa trên trạng thái socket
      if (socketDisconnected && totalAvailable > currentDisplayed) {
        // Socket đã ngắt - hiển thị toàn bộ chuyến bay về còn lại
        setDisplayedFlights(prev => ({
          ...prev,
          chieu_ve: allReturnFlights,
        }));
      } else if (!socketDisconnected && totalAvailable >= currentDisplayed + 5) {
        // Socket còn hoạt động - hiển thị từng batch 5 chuyến
        const nextBatch = currentDisplayed + 5;
        const newDisplayed = allReturnFlights.slice(0, nextBatch);
        setDisplayedFlights(prev => ({
          ...prev,
          chieu_ve: newDisplayed,
        }));
      }
    }
  }, [dataChuyenBay.chieu_ve.length, showReturnFlights, flightWaySelected, socketDisconnected]);

  // Scroll to return flights section when departure flight is selected
  useEffect(() => {
    if(Object.keys(flightWaySelected).length > 0 && searchInfo?.type === "roundtrip") {
      flightToSectionRef?.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, [flightWaySelected]);

  let idChuyenDi = 0,
    idChuyenVe = 0;

  // Hàm reset timeout mỗi khi có dữ liệu mới
  const resetTimeout = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      if (socketRef.current) {
        socketRef.current.disconnect();
      }
      setSocketDisconnected(true);
      setLoading(false);
    }, 60000); // 60s
  };

  useEffect(() => {
    if (!socketRef.current) {
      return;
    }
    socketRef.current.on("sever-sent-data-chieu-di", (data) => {
      data = decodeData(data);
      if (data.end === true) {
        return;
      }
      data.tuy_chon_gia_ve_mac_dinh = data.gia_ve[0];
      setDataChuyenBay((preState) => ({
        ...preState,
        chieu_di: [...preState["chieu_di"], { id: idChuyenDi, ...data }],
      }));
      idChuyenDi = idChuyenDi + 1;
      resetTimeout(); // reset timeout khi có dữ liệu mới
    });

    socketRef.current.on("sever-sent-data-chieu-ve", (data) => {
      data = decodeData(data);
      if (data.end === true) {
        return;
      }
      data.tuy_chon_gia_ve_mac_dinh = data.gia_ve[0];
      setDataChuyenBay((preState) => ({
        ...preState,
        chieu_ve: [...preState["chieu_ve"], { id: idChuyenVe, ...data }],
      }));
      idChuyenVe = idChuyenVe + 1;
      resetTimeout(); // reset timeout khi có dữ liệu mới
    });

    // Cleanup khi unmount hoặc socketRef thay đổi
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [socketRef.current]);

  const handleSubmitSearch = async (values) => {
    setLoading(true);
    
    // Disconnect socket cũ trước để tránh tình trạng nhấn search liên tục
    if (socketRef.current && socketRef.current.connected) {
      socketRef.current.disconnect();
    }
    
    setCheckedStop([]);
    setCheckedAirline([]);
    setFlightToSelected({});
    setFlightWaySelected({});
    setDataChuyenBay({ chieu_di: [], chieu_ve: [] });
    setDisplayedFlights({ chieu_di: [], chieu_ve: [] });
    setShowReturnFlights(false);
    setShowDepartureFlights(true); // Reset về hiển thị chiều đi
    setSocketDisconnected(false);
    setSearchInfo(values);

    socketRef.current = socketIOClient.connect(process.env.REACT_APP_SOCKET);
    socketRef.current.on("connect", async () => {
      // Đảm bảo socket đã kết nối và có ID trước khi gọi API
      if (!socketRef.current || !socketRef.current.connected) {
        setLoading(false);
        return;
      }

      const sid = socketRef.current.id; // ✅ socket id đã sẵn sàng
      
      // Kiểm tra socket ID có tồn tại không
      if (!sid) {
        setLoading(false);
        return;
      }

      console.log("Socket connected with ID:", sid);

      var hangBayMacDinh = ["VN", "QH", "VJ", "VU", "1G", "uAPI"];
      let changBay = [
        {
          index: 0,
          diem_di: values.from.code,
          diem_den: values.to.code,
          ngay_di: formatDate(values.departureDate),
        },
      ];
      if (values.type === "roundtrip") {
        changBay.push({
          index: 1,
          diem_di: values.to.code,
          diem_den: values.from.code,
          ngay_di: formatDate(values.returnDate),
        });
      }

      let res = {
        sid: sid, // ✅ dùng socket id vừa lấy
        chang_bay: changBay,
        nhieu_chang: 0,
        hanh_khach: {
          nguoi_lon: values.passengerCounts.adults,
          tre_em: values.passengerCounts.children,
          em_be: values.passengerCounts.infants,
        },
        hang_bay: hangBayMacDinh,
        tuoi_hanh_khach: values.tuoiHanhKhach ? values.tuoiHanhKhach : [{loai_hanh_khach:  1, tuoi: 0}],
        ve_re_thang: 0,
        ma_khuyen_mai: "",
        xac_nhan_subcode: "",
      };

      // Sử dụng API service
      try {
        const result = await timChuyen(res);
        setApiResponeSocket(result);
      } catch (error) {
        console.error("Lỗi khi gọi API timChuyen:", error);
        setLoading(false);
      }
    });
  };

  useEffect(() => {
    if (apiResponeSocket && apiResponeSocket.code == 200) {
      if (apiResponeSocket.data == 0) {
        setLoading(false);
        socketRef.current.disconnect();
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        return;
      }
      var count = 0;
      var hangBay = [];
      socketRef.current.on("sever-sent-data-end", (data) => {
        if (!hangBay.includes(data)) {
          hangBay.push(data);
          count++;
        }
        if (count == apiResponeSocket.data || apiResponeSocket.data == 0) {
          setSocketDisconnected(true);
          setLoading(false);
          socketRef.current.disconnect();
          if (timeoutRef.current) clearTimeout(timeoutRef.current);
        }
      });
      // Bắt đầu timeout khi bắt đầu nhận dữ liệu
      resetTimeout();
    } else if (apiResponeSocket.code == 400) {
      setLoading(false);
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      setSweetAlert((preState) => ({
        ...preState,
        isShow: true,
        baseProps: {
          title: "Thông báo",
          confirmBtnBsStyle: "success",
          cancelBtnBsStyle: "danger",
          showCloseButton: true,
          showConfirm: false,
          type: "warning",
          onCancel: onCancel,
          ContentRender: <p>{apiResponeSocket.message}</p>,
        },
      }));
    }
  }, [apiResponeSocket]);

  const onCancel = () => {
    setSweetAlert((preState) => ({
      ...preState,
      isShow: false,
    }));
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const updatePassengerCount = (type, operation) => {
    setPassengerCounts((prev) => {
      const newCounts = { ...prev };
      if (operation === "add") {
        newCounts[type] += 1;
      } else if (operation === "subtract" && newCounts[type] > 0) {
        newCounts[type] -= 1;
      }
      return newCounts;
    });
  };

  const getTotalPassengers = () => {
    return (
      passengerCounts.adults +
      passengerCounts.children +
      passengerCounts.infants
    );
  };

  // Hàm lấy danh sách chuyến bay chiều về dựa trên logic
  const getReturnFlights = () => {
    if (!flightWaySelected || Object.keys(flightWaySelected).length === 0) {
      return [];
    }

    if (flightWaySelected.hang_bay.api !== "uAPI") {
      // Hãng bay thường: hiển thị tất cả chuyến về KHÔNG phải uAPI
      return dataChuyenBay.chieu_ve.filter(f => f.hang_bay.api !== "uAPI");
    } else {
      // uAPI: chỉ hiển thị chuyến về có cùng index và là uAPI
      return dataChuyenBay.chieu_ve.filter(
        flight => flight.index === flightWaySelected.index && flight.hang_bay.api === "uAPI"
      );
    }
  };

  // Kiểm tra điều kiện để enable nút "Tiếp tục"
  const isContinueEnabled = () => {
    if (!searchInfo) return false;
    if (searchInfo.type === "roundtrip") {
      return (
        flightWaySelected &&
        Object.keys(flightWaySelected).length > 0 &&
        flightToSelected &&
        Object.keys(flightToSelected).length > 0
      );
    }
    return flightWaySelected && Object.keys(flightWaySelected).length > 0;
  };

  // Hàm xử lý khi nhấn "Tiếp tục"
  const handleContinue = () => {
    if (!isContinueEnabled()) return;
    const flightArr = [];
    if (flightWaySelected && Object.keys(flightWaySelected).length > 0) {
      flightArr.push(flightWaySelected);
    }
    if (
      searchInfo?.type === "roundtrip" &&
      flightToSelected &&
      Object.keys(flightToSelected).length > 0
    ) {
      flightArr.push(flightToSelected);
    }
    if (flightArr.length === 0) return;
    navigate("/thong-tin-hanh-khach", {
      state: {
        passengers: passengerCounts,
        flight: flightArr,
      },
    });
  };

  return (
    <div className="home">
      {loading && <LoadingPage />}
      <FlightSearch
        isDropdownOpen={isDropdownOpen}
        passengerCounts={passengerCounts}
        toggleDropdown={toggleDropdown}
        updatePassengerCount={updatePassengerCount}
        getTotalPassengers={getTotalPassengers}
        handleSubmitSearch={handleSubmitSearch}
      />
      {/* Ẩn explore_area nếu không có chuyến bay nào */}
      {(displayedFlights.chieu_di.length > 0 ||
        displayedFlights.chieu_ve.length > 0) && (
        <section id="explore_area">
          <div className="container">
            <div className="tour_booking_form_box mt-3">
              <div className="row flight-search-container">
                <div className="col-12 col-md-4 col-lg-4 filter-column">
                  <div className="filter-scroll-container">
                    <FlightFilter 
                      stops={dataChuyenBay["chieu_di"].map(cb => cb.chi_tiet_chang_bay?.length || 0)}
                      airlines={dataChuyenBay["chieu_di"].map(cb => cb.hang_bay.ma)}
                      airlinesName={dataChuyenBay["chieu_di"].map(cb => ({
                        ma: cb.hang_bay.ma,
                        ten: cb.hang_bay.ten
                      }))}
                      checkedStop={checkedStop}
                      setCheckedStop={setCheckedStop}
                      checkedAirline={checkedAirline}
                      setCheckedAirline={setCheckedAirline}
                      selectedFlights={(() => {
                        if (searchInfo?.type === "roundtrip") {
                          const arr = [];
                          if (Object.keys(flightWaySelected).length > 0) arr.push(flightWaySelected);
                          if (Object.keys(flightToSelected).length > 0) arr.push(flightToSelected);
                          return arr;
                        }
                        return Object.keys(flightWaySelected).length > 0 ? [flightWaySelected] : [];
                      })()}
                      passengers={passengerCounts}
                      showReturnFlights={showReturnFlights}
                      onChangeDeparture={() => {
                        // Bắt đầu loading transition
                        setPageTransitionLoading(true);
                        
                        setTimeout(() => {
                          setFlightToSelected({}); // Xóa chiều về đã chọn
                          setShowDepartureFlights(true);
                          setShowReturnFlights(false);
                          // Tắt loading transition sau 0.3s
                          setPageTransitionLoading(false);
                          
                          // Scroll lên card thông tin chiều đi sau khi hiển thị
                          setTimeout(() => {
                            const departureInfoCard = document.querySelector('[data-departure-info-card]');
                            if (departureInfoCard) {
                              departureInfoCard.scrollIntoView({
                                behavior: "smooth",
                                block: "start",
                                inline: "nearest"
                              });
                            }
                          }, 100); // Delay nhỏ để đảm bảo DOM đã render
                        }, 300); // Loading 0.3s
                      }}
                      isRoundtrip={searchInfo?.type === "roundtrip"}
                      searchInfo={searchInfo}
                    />
                  </div>
                </div>
                <div className="col-12 col-md-8 col-lg-8 result-column">
                  <div className="result-scroll-container pt-0" style={{ position: 'relative' }}>
                  
                  {/* Loading overlay khi chuyển page */}
                  {pageTransitionLoading && (
                    <div style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      backgroundColor: 'rgba(255, 255, 255, 0.9)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      zIndex: 1000,
                      borderRadius: '8px'
                    }}>
                      <div style={{ textAlign: 'center' }}>
                        <div className="spinner-border text-primary mb-2" role="status" style={{ 
                          width: '2rem', 
                          height: '2rem',
                          borderWidth: '0.2em'
                        }}>
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    </div>
                  )}
                  
                  {/* Hiển thị chiều đi */}
                  {showDepartureFlights && (
                    <div>
                      {/* Thông tin chiều đi từ searchInfo */}
                      {searchInfo && (
                        <div
                          data-departure-info-card
                          style={{
                            marginBottom: 16,
                            borderRadius: 12,
                            padding: 16,
                            background:
                              "linear-gradient(90deg, #e0f0ff 0%, #b3d8ff 100%)",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
                            display: "inline-block",
                            minWidth: 320,
                          }}
                        >
                          <b>
                            Điểm đi: {searchInfo.from?.code} &nbsp;|&nbsp; Điểm
                            đến: {searchInfo.to?.code} &nbsp;|&nbsp; Ngày đi:{" "}
                            {formatDate(searchInfo.departureDate)?.replaceAll("-", "/")}
                          </b>
                        </div>
                      )}
                      <FlightResult
                        passengerCounts={passengerCounts}
                        dataChuyenBayDefault={displayedFlights["chieu_di"]}
                        setFlightSelected={handleFlightWaySelected}
                        selectedFlight={flightWaySelected}
                        checkedStop={checkedStop}
                        checkedAirline={checkedAirline}
                        socketDisconnected={socketDisconnected}
                      />
                    </div>
                  )}
                  
                  {/* Hiển thị chiều về khi đã chọn chiều đi và là roundtrip */}
                  {searchInfo?.type === "roundtrip" && Object.keys(flightWaySelected).length > 0 && !showDepartureFlights && (
                    <div ref={flightToSectionRef} className="mt-3">
                      {showReturnFlights ? (
                        <>
                          {/* Thông tin chiều về từ searchInfo */}
                          {searchInfo && (
                            <div
                              data-return-info-card
                              style={{
                                marginBottom: 16,
                                borderRadius: 12,
                                padding: 16,
                                background:
                                  "linear-gradient(90deg, #e0f0ff 0%, #b3d8ff 100%)",
                                boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
                                display: "inline-block",
                                minWidth: 320,
                              }}
                            >
                              <b>
                                Điểm đi: {searchInfo.to?.code} &nbsp;|&nbsp; Điểm
                                đến: {searchInfo.from?.code} &nbsp;|&nbsp; Ngày
                                đi: {formatDate(searchInfo.returnDate)?.replaceAll("-", "/")}
                              </b>
                            </div>
                          )}
                          <FlightResult
                            passengerCounts={passengerCounts}
                            dataChuyenBayDefault={displayedFlights.chieu_ve}
                            setFlightSelected={handleFlightToSelected}
                            selectedFlight={flightToSelected}
                            checkedStop={checkedStop}
                            checkedAirline={checkedAirline}
                            socketDisconnected={socketDisconnected}
                          />
                        </>
                      ) : null}
                    </div>
                  )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {sweetAlert.isShow === true && (
        <SweetAlert {...sweetAlert.baseProps}>
          {sweetAlert.baseProps.ContentRender}
        </SweetAlert>
      )}

      {/* Floating Continue Button - hiển thị khi có chuyến bay được chọn */}
      {(flightWaySelected && Object.keys(flightWaySelected).length > 0) && (
        <div style={{
          position: 'fixed',
          bottom: '20px',
          left: '50%',
          transform: 'translateX(-50%)',
          zIndex: 1000,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
          <div style={{
            background: '#fff',
            borderRadius: '50px',
            padding: '12px 24px',
            boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
            border: '1px solid #e9ecef',
            display: 'flex',
            alignItems: 'center',
            gap: '15px',
            minWidth: '320px',
            maxWidth: '90vw'
          }}>
            {/* Thông tin chuyến đã chọn */}
            <div style={{
              fontSize: '13px',
              color: '#666',
              lineHeight: '1.3',
              flex: 1
            }}>
              {searchInfo?.type === "roundtrip" ? (
                <div>
                  <div style={{ fontWeight: '600', color: '#333' }}>
                    {flightWaySelected.diem_di.ma} → {flightWaySelected.diem_den.ma}
                    <span style={{ color: '#28a745', marginLeft: '6px' }}>
                      <i className="fas fa-check-circle" style={{ fontSize: '12px' }}></i>
                    </span>
                  </div>
                  <div style={{ marginTop: '2px', fontWeight: '600', color: '#333' }}>
                    {flightToSelected && Object.keys(flightToSelected).length > 0 ? (
                      <>
                        {flightToSelected.diem_di.ma} → {flightToSelected.diem_den.ma}
                        <span style={{ color: '#28a745', marginLeft: '6px' }}>
                          <i className="fas fa-check-circle" style={{ fontSize: '12px' }}></i>
                        </span>
                      </>
                    ) : (
                      <span style={{ color: '#ffc107' }}>
                        <i className="fas fa-clock me-1" style={{ fontSize: '11px' }}></i>
                        Chờ chọn chiều về
                      </span>
                    )}
                  </div>
                </div>
              ) : (
                <div style={{ fontWeight: '600', color: '#333' }}>
                  {flightWaySelected.diem_di.ma} → {flightWaySelected.diem_den.ma}
                  <span style={{ color: '#28a745', marginLeft: '6px' }}>
                    <i className="fas fa-check-circle" style={{ fontSize: '12px' }}></i>
                  </span>
                </div>
              )}
            </div>

            {/* Nút Tiếp tục */}
            <button
              className={`btn ${isContinueEnabled() ? 'btn-primary' : 'btn-secondary'}`}
              onClick={handleContinue}
              disabled={!isContinueEnabled()}
              style={{
                minWidth: '120px',
                padding: '10px 20px',
                fontSize: '15px',
                fontWeight: '600',
                borderRadius: '25px',
                transition: 'all 0.2s ease',
                border: 'none',
                ...(isContinueEnabled() ? {
                  background: 'linear-gradient(135deg, #007bff 0%, #0056b3 100%)',
                  color: '#fff',
                  transform: 'translateY(0)',
                  boxShadow: '0 4px 12px rgba(0,123,255,0.3)'
                } : {
                  background: '#6c757d',
                  color: '#fff',
                  opacity: 0.7,
                  cursor: 'not-allowed'
                })
              }}
              onMouseEnter={(e) => {
                if (isContinueEnabled()) {
                  e.target.style.transform = 'translateY(-2px)';
                  e.target.style.boxShadow = '0 6px 20px rgba(0,123,255,0.4)';
                }
              }}
              onMouseLeave={(e) => {
                if (isContinueEnabled()) {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 4px 12px rgba(0,123,255,0.3)';
                }
              }}
            >
              <i className="fas fa-arrow-right me-2"></i>
              Tiếp tục
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
